var __rspack_ns_object = JSON.parse('{"a:1:gbp:1":1,"a:2:eur:2":2,"a:3:usd:3":3,"a:4:zar:4":4}')